import { useState } from "react";

export function useCrud<T>(onDeleteApi?: (id: any) => void) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<T | null>(null);

  const handleCreate = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleEdit = (item: T) => {
    setEditing(item);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return {
    open,
    editing,
    handleCreate,
    handleEdit,
    handleClose,
    onDelete: onDeleteApi
  };
}